/**
 * The localStorage instance, or null when it is unavailable (SSR, node test
 * environments, or storage disabled by the browser). Lets callers skip
 * persistence silently instead of throwing.
 */
export const safeLocalStorage = (): Storage | null => {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    return null;
  }
};
